function openCloseModalACF(modal, action) {
  const sizeChart = document.querySelector(modal);
  if (action) {
    sizeChart.classList.add('dn-i')
    document.querySelector('body').style.overflow = 'auto';
  }
  if (!action) {
    sizeChart.classList.remove('dn-i')
    document.querySelector('body').style.overflow = 'hidden';
  }
}

function openTab(e, tabName) {
  const tabContents = document.querySelectorAll('.size_chart__body-tab-content');
  const tabLinks = document.querySelectorAll('.size-chart__tablinks');

  tabContents.forEach(content => content.classList.add('dn-i'));
  tabLinks.forEach(link => link.classList.remove('btn-dark'));

  e.target.classList.add('btn-dark');
  document.querySelector(`.size_chart__body-tab-content[data-tab='${tabName}']`).classList.remove('dn-i')
}

const modalModule = (function () {
  let scrollPosition = 0;

  function showModal(modal) {
    const sizeChart = document.querySelector(modal);
    if (sizeChart) {
      scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      document.body.classList.add('scroll-blocked');
      document.documentElement.classList.add('scroll-blocked-html');
      sizeChart.classList.remove('dn-i');
      initMeasureTable();
    }
  }

  function hideModal(modal) {
    const sizeChart = document.querySelector(modal);
    if (sizeChart) {
      document.body.classList.remove('scroll-blocked');
      document.documentElement.classList.remove('scroll-blocked-html');
      sizeChart.classList.add('dn-i');
      window.scrollTo(0, scrollPosition);
    }
  }

  return {
    openModal: showModal,
    closeModal: hideModal
  };
})();


function initMeasureTable() {
  const cellValues = document.querySelectorAll('.size_chart__body-tab-content__tab-size-guide td');

  cellValues.forEach((cell) => {
    // Obtener el valor original desde el textContent
    let originalValue = cell.textContent.trim();

    // Verificar si el valor contiene una medida numérica o un rango seguido de texto adicional entre paréntesis
    let rangeMatch = originalValue.match(/^([\d.]+)"?\s*-\s*([\d.]+)"?(?:\s*\(([^)]+)\))?$/);
    if (rangeMatch) {
      let minNumericValue = parseFloat(rangeMatch[1]);
      let maxNumericValue = parseFloat(rangeMatch[2]);
      let additionalText = rangeMatch[3] ? ` (${rangeMatch[3]})` : '';

      // Convertir los valores a pulgadas y centímetros
      let minCmValue = (minNumericValue * 2.54).toFixed(1);
      let maxCmValue = (maxNumericValue * 2.54).toFixed(1);

      cell.dataset.cm = `${minCmValue}-${maxCmValue}cm${additionalText}`;
      cell.dataset.inches = originalValue;
    } else {
      let numericMatch = originalValue.match(/^([\d.]+)"?(?:\s*\(([^)]+)\))?$/);
      if (numericMatch) {
        let numericValue = parseFloat(numericMatch[1]);
        let additionalText = numericMatch[2] ? ` (${numericMatch[2]})` : '';

        // Convertir el valor a pulgadas y centímetros
        let cmValue = (numericValue * 2.54).toFixed(1);

        cell.dataset.cm = `${cmValue}cm${additionalText}`;
        cell.dataset.inches = originalValue;
      }
    }
  });
}

function measureTableCm_In() {
  var inCmToggleBtn = document.querySelector('.slider-toggle');
  if (!inCmToggleBtn) return;

  var currentMeasure = inCmToggleBtn.dataset.measure;

  const cellValues = document.querySelectorAll('.size_chart__body-tab-content__tab-size-guide td');
  inCmToggleBtn.dataset.measure = currentMeasure === 'cm' ? 'in' : 'cm';

  cellValues.forEach((cell) => {
    if (currentMeasure === 'cm') {
      if (cell.dataset.cm != undefined) {
        cell.textContent = cell.dataset.cm;

      }

    } else {
      if (cell.dataset.inches != undefined) {
        cell.textContent = cell.dataset.inches;

      }
    }
  });
}

function initSizeGuideListeners() {
  const sizeGuideButton = document.querySelectorAll('.size-guide__poppup');

  sizeGuideButton.forEach((button) => {
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);

    newButton.addEventListener('click', function (event) {
      event.preventDefault();
      modalModule.openModal('.size-chart-acf__modal');
    });
  });

  const sliderToggle = document.querySelector('.slider-toggle');
  if (sliderToggle) {
    const newToggle = sliderToggle.cloneNode(true);
    sliderToggle.parentNode.replaceChild(newToggle, sliderToggle);
    newToggle.addEventListener('click', measureTableCm_In);
  }
}

// Expose functions globally
window.initMeasureTable = initMeasureTable;
window.initSizeGuideListeners = initSizeGuideListeners;

// Initial load
document.addEventListener('DOMContentLoaded', () => {
  initSizeGuideListeners();
});





